import SVG from "../../../Components/SVG";
import Custom from "../../../Components/Buttons/Custom";
import Certificate from "../../..//Media/PNG/certificate.png";

const isPrivateMediaUrl = (url) => String(url || "").includes("/private-media/");

const getAuthHeaders = () => {
  const access = localStorage.getItem("access");
  return access ? { Authorization: `Bearer ${access}` } : {};
};

const getCertificateFileName = (title) => {
  const safeTitle = String(title || "certificate")
    .trim()
    .replace(/[\\/:*?"<>|]/g, "-");

  return `${safeTitle || "certificate"}.png`;
};

const downloadBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export default function Card({
  title,
  imageSrc = Certificate,
  downloadUrl = "",
  isLock = true,
  isBlured = true,
  isAchieved = false,
  isForExplanation = true,
  onHelp,
  onHowTo,
  onCardClick,
}) {
  const handleDownload = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!downloadUrl) {
      return;
    }

    try {
      const response = await fetch(downloadUrl, {
        method: "GET",
        headers: isPrivateMediaUrl(downloadUrl) ? getAuthHeaders() : {},
      });

      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const blob = await response.blob();
      downloadBlob(blob, getCertificateFileName(title));
    } catch (error) {
      console.error("Error downloading certificate:", error);
      window.open(downloadUrl, "_blank", "noopener,noreferrer");
    }
  };

  const handleShare = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!navigator.share) {
      console.warn("Web Share API is not supported in this browser.");
      return;
    }

    try {
      await navigator.share({
        title: title || "certificate",
        url: downloadUrl || imageSrc || window.location.href,
      });
    } catch (error) {
      if (error?.name !== "AbortError") {
        console.error("Error sharing certificate:", error);
      }
    }
  };

  return (
    <div
      className={`max-w-sm w-full flex flex-col gap-2.5 ${typeof onCardClick === "function" ? "cursor-pointer" : ""}`}
      onClick={onCardClick}
    >
      <div className="w-full flex justify-between items-center">
        <span className="font-medium text-lg sm:text-xl text-zi-text-light dark:text-zi-text-dark">
          {title}
        </span>
        <button className="flex items-center gap-1.5 bg-zi-inputbg-dark px-2 py-1 rounded-md"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof onHelp === "function") {
            onHelp();
          }
        }}
        >
          <SVG name="infoCircle" classname="stroke-zi-text-light fill-zi-text-light dark:stroke-zi-text-dark dark:fill-zi-text-dark" />
          <span className="hidden sm:inline text-zi-text-light/70 dark:text-zi-text-dark/80 text-sm font-light">توضیحات</span>
        </button>
        {/* <Custom
          text="توضیحات"
          href=""
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (typeof onHelp === "function") {
              onHelp();
            }
          }}
          className="!text-sm !rounded-lg !py-1.5 !px-3 bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark hocus:ring-1 hocus:ring-zi-border-dark"
          svg_name="infoCircle"
          svgClassName="stroke-zi-text-light fill-zi-text-light dark:stroke-zi-text-dark dark:fill-zi-text-dark"
        /> */}
      </div>

      <div className="relative w-full rounded-2xl overflow-hidden">
        <img src={imageSrc || Certificate} alt={title} loading="lazy" className="max-w-full max-h-full object-cover"/>
        {isLock && (
          <div
            className={`absolute top-0 bottom-0 size-full ${isBlured ? "backdrop-blur-sm bg-black/30" : ""}  flex justify-center items-center`}
          >
            <div
              className={`p-2.5 flex justify-center items-center  rounded-lg ${isBlured ? "bg-zi-bg2-light/30" : "bg-zi-bg2-dark/30"}`}
            >
              <SVG
                name="lock"
                classname={` size-7 sm:size-9 ${isBlured ? "stroke-zi-text-dark" : "stroke-zi-text-dark"}`}
              />
            </div>
          </div>
        )}
        {isAchieved && (
          <div
            className={`absolute top-0 bottom-0 size-full ${isBlured ? "backdrop-blur-sm bg-black/30" : ""}  flex justify-center items-center`}
          >
            <div
              className={`p-2.5 flex justify-center items-center  rounded-lg ${isBlured ? "bg-zi-bg2-light/30" : "bg-zi-bg2-dark/30"}`}
            >
              <SVG
                name="certificate"
                classname={` size-7 sm:size-9 ${isBlured ? "stroke-zi-text-dark" : "stroke-zi-text-dark"}`}
              />
            </div>
          </div>
        )}
      </div>

      <div className="w-full flex gap-2.5">
        {isForExplanation === true ? (
          <Custom
            text="راهنمای دریافت گواهی‌نامه"
            href=""
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (typeof onHowTo === "function") {
                onHowTo();
              }
            }}
            className="w-full border border-zi-border-dark dark:border-zi-border-light/30 !text-sm !rounded-lg !py-1.5 !px-3 bg-transparent text-zi-text-light dark:text-zi-text-dark/80 hocus:dark:border-zi-border-light/60"
          />
        ) : (
          <>
            <Custom
              text="دانلود فایل"
              svg_name="download"
              svgClassName="stroke-zi-text-dark"
              onClick={handleDownload}
              className="w-full !text-sm !rounded-lg !py-1.5 !px-3 bg-zi-buttonbg-primary text-zi-text-dark hocus:opacity-85"
            />
            <Custom
              text="اشتراک‌گذاری"
              svg_name="share"
              svgClassName="stroke-zi-text-light dark:stroke-zi-text-dark"
              onClick={handleShare}
              className="w-full border border-zi-border-dark !text-sm !rounded-lg !py-1.5 !px-3 bg-transparent text-zi-text-light dark:text-zi-text-dark hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
            />
          </>
        )}
      </div>
    </div>
  );
}
